import React, { useEffect } from 'react';
import Dialog from "../../components/controls/Dialog";
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import * as maskingConfigService from '../../services/maskingConfigService';
import Input from '../../components/controls/Input';
import { useForm } from '../../components/useForm';
import useAlert from '../../components/useAlert';

const initialFValues = {
    id: '',
    regExp: '',
    replacement: ''
}

const MaskingConfigDialog = (props) => {
    const { open, selectedRow, getMaskingConfigs } = props;

    const {
        values,
        setValues,
        errors,
        handleInputChange,
        handleClose,
        handleError
    } = useForm(initialFValues, props);

    useEffect(() => {
        if (open)
            handleAlertClose();
        if (selectedRow)
            setValues({
                ...selectedRow,
                replacement: selectedRow.replacement ?? ''
            });
        else
            setValues(initialFValues);
        //eslint-disable-next-line
    }, [selectedRow, open])

    const {
        Alert,
        status,
        showSuccess,
        showError,
        handleAlertClose
    } = useAlert();

    const submit = () => {
        if (validate()) {
            const payload = {
                ...values,
                replacement: values.replacement === '' ? null : values.replacement
            };

            if (selectedRow)
                maskingConfigService.updateMaskingConfig(selectedRow.id, payload)
                    .then(() => {
                        showSuccess();
                        handleClose();
                        getMaskingConfigs();
                    })
                    .catch(error => {
                        showError(error.response?.data?.message || "Error updating Masking Config");
                        handleError(error.response?.data?.fields);
                    });
            else
                maskingConfigService.createMaskingConfig(payload)
                    .then(() => {
                        showSuccess();
                        handleClose();
                        getMaskingConfigs();
                    })
                    .catch(error => {
                        showError(error.response?.data?.message || "Error creating Masking Config");
                        handleError(error.response?.data?.fields);
                    });
        }
    };

    const validate = () => {
        let temp = {}
        temp.id = values.id ? "" : "ID is required";
        temp.regExp = values.regExp ? "" : "Regular expression is required";
        return Object.values(temp).every(x => x === '');
    }

    return (
        <React.Fragment>
            {status ? <Alert /> : null}
            <Dialog
                title={selectedRow ? "Edit Masking Config" : "Create new Masking Config"}
                open={open}
                handleClose={handleClose}>
                <DialogContent>
                    <Input
                        {...(selectedRow && { disabled: true })}
                        label="Masking Config ID"
                        name="id"
                        defValue={values.id}
                        onChange={handleInputChange}
                        error={errors.id}
                    />
                    <Input
                        label="Regular Expression"
                        name="regExp"
                        defValue={values.regExp}
                        onChange={handleInputChange}
                        error={errors.regExp}
                    />
                    <Input
                        label="Replacement"
                        name="replacement"
                        defValue={values.replacement}
                        onChange={handleInputChange}
                        error={errors.replacement}
                    />
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={handleClose}>Cancel</Button>
                    <Button variant="contained" onClick={submit}>Save</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}

export default MaskingConfigDialog;
